import styled from 'styled-components';

const ItemImageStyle = styled.div``;

const ItemStyle = styled.div`
  flex-direction: column;
  //gap: 4px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;

  ${(props) =>
    props.$isActive &&
    `
    border-radius: 8px;
    background: #FF9704;
    `};

  ${(props) =>
    props.isDisabled &&
    `
      opacity:0.4;
      cursor: not-allowed;
  `}

  @media (orientation: portrait) {
    width: 44px;
    //width: 63px;
    flex: 0 1 63px;
    height: 54px;
    padding-bottom: 4px;
    padding: 0 10px;
    display: inline-flex;
  }
  @media (orientation: landscape) {
    width: 50px;
    padding: 0 10px;
    width: 63px;
    height: 54px;
    left: 36px;
    display: flex;
  }
`;

const TextStyle = styled(ItemStyle)`
  text-align: center;
  color: white;
  font-weight: 400;
  overflow-wrap: normal;
  color: #edeff5;

  @media (orientation: portrait) {
    font-size: 10px;
    line-height: 10px;
    height: 10px;
  }
  @media (orientation: landscape) {
    width: 50px;
    font-size: 9.09px;
  }
`;

export { ItemImageStyle, ItemStyle, TextStyle };
